export const SET_USER_LOGIN_LOADING_TRUE = "SET_USER_LOGIN_LOADING_TRUE";
export const SET_USER_LOGIN_LOADING_FALSE = "SET_USER_LOGIN_LOADING_FALSE";
export const SET_USER_AFTER_LOGIN = "SET_USER_AFTER_LOGIN";
export const SET_USER_AFTER_REFRESH = "SET_USER_AFTER_REFRESH";
export const SET_USER_AFTER_LOGOUT = "SET_USER_AFTER_LOGOUT";
export const SET_DELETE_USER_LOADING_TRUE = "SET_DELETE_USER_LOADING_TRUE";
export const SET_DELETE_USER_LOADING_FALSE = "SET_DELETE_USER_LOADING_FALSE";
export const SET_APP_LOADING_TRUE = "SET_APP_LOADING_TRUE";
export const SET_APP_LOADING_FALSE = "SET_APP_LOADING_FALSE";
